import { getChildBundleItemsBySKU } from 'hooks/useStorefront'
/**
 * Used to generate swatches
 * @param { Array<string> } skus
 * @returns { 'Out of stock' | 'Pre-order' | 'available' }
 */
const getChildStockStatus = async (bundleChildItems) => {
  let enableLogging = false
  let childrenBundleStatus = 'available'
  if (!bundleChildItems?.length) {
    childrenBundleStatus = 'Out of stock'

    return childrenBundleStatus
  }

  if (['127.0.0.1', 'localhost'].includes(location.hostname)) {
    enableLogging = true
  }

  if (enableLogging) {
    console.log('bundleChildItems', bundleChildItems)
  }
  const childProductsSkus = bundleChildItems.map((childItem) => childItem.sku)
  const childProducts = await getChildBundleItemsBySKU(childProductsSkus)
    .then((res) => {
      if (!res.ok || !res.json) {
        throw res
      }
      return res.json()
    })
    .then((body) => {
      if (body.errors) {
        throw body
      }

      const bundleProducts = body.data.search.edges.map((x) => x.node).filter(x => Object.keys(x).length)

      // Filter out products that don't match the child product SKUs
      const filteredBundleProducts = bundleProducts.filter((prod) =>
        prod.variants.edges.some((variant) => childProductsSkus.includes(variant.node.sku))
      )

      const bundleCompWithQty = filteredBundleProducts.map((prod) => {
        // include the qty composition of individual child items in the array object
        const matchedProduct = bundleChildItems.filter((childItem) => childItem.sku === prod?.variants?.edges[0].node.sku)
        if (matchedProduct && matchedProduct.length) prod.qty = matchedProduct[0].qty
        prod.onHandStock = prod?.variants?.edges[0].node.onHandStock
        prod.futureStock = prod?.variants?.edges[0].node.futureStock
        prod.preOrderDate = prod?.variants?.edges[0].node.preOrderDate
        return prod
      })
      if (enableLogging) {
        console.log('filteredBundleProducts', filteredBundleProducts)
        console.log('bundleCompWithQty', bundleCompWithQty)
      }
      return bundleCompWithQty
    })
    .catch((err) => {
      console.error('Some error during getChildStockStatus', err)
      return []
    })

  if (enableLogging) {
    console.log('childProducts', childProducts)
  }
  const outOfStockBundleChild = childProducts.filter((childProduct) => {
    const noOnHandStock = childProduct.onHandStock === null || childProduct.onHandStock?.value === '0'
    const noFutureStock = childProduct.futureStock === null || childProduct.futureStock?.value === '0'
    const onHandStockLevel = parseInt(childProduct.onHandStock?.value ?? 0)
    const futureStockLevel = parseInt(childProduct.futureStock?.value ?? 0)

    const bothLevelsZero = noOnHandStock && noFutureStock
    const metafieldLevelsBelowShopifyLevels = onHandStockLevel + futureStockLevel < childProduct.qty
    if (enableLogging) {
      console.log('childProduct', {
        childProduct,
        noOnHandStock,
        noFutureStock,
        onHandStockLevel,
        futureStockLevel,
        bothLevelsZero,
        metafieldLevelsBelowShopifyLevels
      })
    }
    return bothLevelsZero || metafieldLevelsBelowShopifyLevels
  })

  const preOrderStockBundleChild = childProducts.filter(
    (childProduct) => parseInt(childProduct.onHandStock?.value) === 0 && parseInt(childProduct.futureStock?.value) >= childProduct.qty
  )

  if (enableLogging) {
    console.log('outOfStockBundleChild', outOfStockBundleChild)
    console.log('preOrderStockBundleChild', preOrderStockBundleChild)
  }

  if (outOfStockBundleChild.length > 0) {
    childrenBundleStatus = 'Out of stock'
  } else if (preOrderStockBundleChild.length > 0) {
    childrenBundleStatus = 'Pre-order'
  } else {
    childrenBundleStatus = 'available'
  }

  const poDates = preOrderStockBundleChild.map(product => product?.preOrderDate?.value)
  // console.log('childrenBundleStatus', childrenBundleStatus)
  return { childrenBundleStatus, poDates }
}
export { getChildStockStatus }
